// extracted by mini-css-extract-plugin
export default {"whiteBack":"HomeBodyItem_whiteBack__hXw33","blackBack":"HomeBodyItem_blackBack__jemdv"};